import React, { useState } from 'react';
import ResponsiveModal from './ResponsiveModal';
import Button from './Button';
import { HugeiconsIcon } from '@hugeicons/react';
import { Calendar03Icon } from '@hugeicons/core-free-icons';

const DateRangeModal = ({ isOpen, onClose, onApply }) => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const handleApply = () => {
    onApply(startDate, endDate);
    onClose();
  };

  return (
    <ResponsiveModal isOpen={isOpen} onClose={onClose} title="Select Date Range">
      <div className="py-6 space-y-6">
        <div className="flex flex-col items-center justify-center p-6 bg-off-white/50 dark:bg-gray-800/50 rounded-[2rem] border border-light-gray/20 dark:border-gray-700/20">
          <div className="bg-soft-green/10 p-4 rounded-full mb-4">
            <HugeiconsIcon icon={Calendar03Icon} size={32} className="text-soft-green" />
          </div>
          <p className="text-center text-muted-gray text-sm">
            Choose a start and end date to filter your transaction history.
          </p>
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-xs font-black text-charcoal dark:text-white uppercase tracking-widest mb-2 px-1">Start Date</label>
            <input 
              type="date" 
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="w-full px-4 py-3 bg-off-white dark:bg-gray-800 border border-light-gray/20 dark:border-gray-700 rounded-2xl focus:ring-2 focus:ring-soft-green outline-none font-bold text-charcoal dark:text-white"
            />
          </div>
          <div>
            <label className="block text-xs font-black text-charcoal dark:text-white uppercase tracking-widest mb-2 px-1">End Date</label>
            <input 
              type="date" 
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="w-full px-4 py-3 bg-off-white dark:bg-gray-800 border border-light-gray/20 dark:border-gray-700 rounded-2xl focus:ring-2 focus:ring-soft-green outline-none font-bold text-charcoal dark:text-white"
            />
          </div>
        </div>

        <div className="pt-2">
          <Button 
            onClick={handleApply} 
            disabled={!startDate || !endDate}
            className="w-full py-4 rounded-2xl text-lg font-black shadow-float disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Apply Filter
          </Button>
        </div>
      </div>
    </ResponsiveModal>
  );
};

export default DateRangeModal;
